import '@babel/polyfill';
import '@formatjs/intl-getcanonicallocales/polyfill';
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/he';
import '@formatjs/intl-pluralrules/locale-data/es';
import '@formatjs/intl-pluralrules/locale-data/ru';
import '@formatjs/intl-pluralrules/locale-data/fr';
import '@formatjs/intl-pluralrules/locale-data/yi';
import '@formatjs/intl-pluralrules/locale-data/ar';
import '@formatjs/intl-pluralrules/locale-data/pt';
import '@formatjs/intl-pluralrules/locale-data/de';
import '@formatjs/intl-pluralrules/locale-data/nl';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import CampaignPage from 'client/components/CampaignPage';
import * as axios from 'client/helpers/axios';
import { createStore, history } from 'client/components/CampaignPage/redux';

axios.setup();

const store = createStore();

const applicationRootElement = document.getElementById('app');

if (applicationRootElement) {
    render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <CampaignPage />
            </ConnectedRouter>
        </Provider>,
        applicationRootElement,
    );
}
